import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { EMPTY, from, merge, Observable, Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@aihub/core/authorization';
import { DomSanitizer } from '@angular/platform-browser';
import { PdfReaderService } from '../../pdf-reader.service';
import { catchError, debounceTime, finalize, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as SAMPLE_DATA from './sample.constant';
import * as PROMPTS from './prompt.constant';
import { Chat, Message, MessageData } from '../../types';
import { PostgenieService } from './postgenie.service';

@Component({
    selector: 'app-postgenie',
    templateUrl: './postgenie.component.html',
    styleUrls: ['./postgenie.component.css'],
})
export class PostgenieComponent implements OnInit {
    @Input() subscription_id: string = '';
    @Input() response;
    @Output() displayResponse = new EventEmitter<any>();
    text: string = '';
    audio;
    audioBlobUrl;
    stopPalm = false;
    public formJson;
    form: FormGroup;
    public uploadIcon = false;
    showForm = false;
    selectedOption = 'file';
    fileContent = '';
    fileName = '';
    platforms = ['LinkedIn'];
    postDescriptions = [
        {
            text: 'Importance of Sustainability',
            icon: 'autorenew',
            value: 'The importance of sustainability. How can consultants help their clients become more sustainable? What are the latest trends in sustainability?',
        },
        {
            text: 'Rise of automation',
            icon: 'whatshot',
            value: 'The rise of automation. How is automation changing the consulting industry? What are the challenges and opportunities that automation presents?',
        },
        { text: 'Future of work', icon: 'people_outline', value: 'The future of work: How will the changing nature of work impact consultants? What skills will be in demand in the future?' },
        {
            text: 'Importance of data analytics',
            icon: 'apps',
            value: 'The importance of data analytics: How can consultants use data analytics to improve their work? What are the latest trends in data analytics?',
        },
        {
            text: 'Need for diversity and inclusion',
            icon: '360',
            value: 'The need for diversity and inclusion: How can consultants create more inclusive and diverse workplaces? What are the benefits of diversity and inclusion?',
        },
    ];

    constructor(private formBuilder: FormBuilder, private postgenieService: PostgenieService, private http: HttpClient, private sanitizer: DomSanitizer, private pdfReader: PdfReaderService) {}

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.form = this.formBuilder.group({
            platform: ['LinkedIn'],
            postDescription: [''],
            audience: [''],
            tone: [''],
            language: [''],
            emoticons: [true],
            hashtags: [true],
            bulletPoints: [true],
        });

        this.showForm = true;
    }

    onSubmit() {
        let promptInput = '';
        promptInput = PROMPTS.post_generator;
        promptInput = promptInput + (this.form.value.postDescription !== '' ? PROMPTS.description + this.form.value.postDescription + 'Do not include any bullet points in the output.' : '');
        promptInput = promptInput + (this.form.value.audience !== '' ? PROMPTS.audience + this.form.value.audience : '');
        promptInput = promptInput + (this.form.value.tone !== '' ? PROMPTS.tone + this.form.value.tone : '');

        const bulletPointsPrompt = this.form.value.bulletPoints ? PROMPTS.bulletsYes : PROMPTS.bulletsNo;
        const hashtagsPrompt = this.form.value.hashtags ? PROMPTS.hashtagsYes : PROMPTS.hashtagsNo;

        promptInput =
            promptInput +
            `\n
      The output should ONLY be html with the following example html structure:

      <html class="linkedin-post-generator">
          <body>
            <div class="card p-3">
              <h4 class="h4">{{Include the title of the post here}}</h4>
			          {{ Response content with no more than 100 words should be displayed here }}
                {{ ${hashtagsPrompt} }}
            </div>
          </body>
      </html>

      stop 100
    \n`;

        // {{ ${bulletPointsPrompt} }}
        // {{ ${hashtagsPrompt} }}

        console.log(promptInput);
        this.getPostsWithVariations(promptInput);
        this.showHotTopics();
        // this.showInterestingInsights();
        this.showRecentPosts();
    }

    getPostsWithVariations(promptInput: string) {
        this.callPalm(promptInput, 0.3);
        this.callPalm(promptInput, 0.2);
        this.postgenieService.sendPrompt(promptInput);
    }

    callPalm(promptInput: string, temperature: number) {
        const modelParams = {
            max_output_tokens: 400,
            temperature: temperature,
            truncate_at_eos: true,
            do_sample: true,
            top_p: 0.95,
            top_k: 40,
        };
        const input = {
            promptString: promptInput,
            model: 'text-bison',
            modelParams,
        };
        this.displayResponse.emit(input);
    }

    showHotTopics() {
        // First of all remember to NOT include any images or img tags in your output.
        // You have generated content for linkedin post on the topic: ${this.form.value.postDescription}.
        // {{Include only 4 hot topics in 4 bullet points here which are related to ${this.form.value.postDescription}. Each bullet point should not have more than 10 words.}}

        let promptInput = `\n
      You are a friendly personal assistant.
      Can you give me the list of top 5 Linkedin profiles who I can follow to know more about the following topic: ${this.form.value.postDescription}
      You should use the below example HTML structure to create the output:
      <!-- Start of Example -->
      <html id="hot-topics">
          <body>
            <div class="card p-3">
              <p class="tip-heading">People currently talking about this topic:</p>
                <ul>
                  <li>
                  {{  List of names of people in Linkedin. Do not include more than 5 people. Do not repeat the names.}}
                  </li>
                </ul>
            </div>
          </body>
      </html>
      <!-- End of Example -->

      Do not include <img> tags in your response.
    \n`;

        // {{Generate atleast one emoticon per bullet point in unicode representation that can be rendered in web application. }}

        this.callPalm(promptInput, 0.5);
    }

    showInterestingInsights() {
        // First of all remember to NOT include any images or img tags in your output.
        // You have generated content for linkedin post on the topic: ${this.form.value.postDescription}.
        let promptInput = `\n
    You are a friendly personal assistant.

    You should use the below example HTML structure to create the output:
    <!-- Start of Example -->
      <html id="insights">
          <body>
            <div class="card p-3">
              <p class="tip-heading">Interesting insights about your profile</p>
                <ul>
                  <li>
                    {{Include here not more than 4 important insights about the following linkedin profile: https://www.linkedin.com/in/sukeshkumarbatchu/}}
                  </li>
                </ul>
            </div>
          </body>
      </html>
      <!-- End of Example -->

      Do not include the following html tags in your response: <a>, <img>

    \n`;

        // {{Generate atleast one emoticon per bullet point in unicode representation that can be rendered in web application. }}

        // <div class="card p-3">
        //   <p class="tip-heading">Some key tips on promoting this post</p>
        //     <ul>
        //       <li>
        //         {{Include here not more than 4 important tips as bullet points on promoting this post on linkedin which is related to ${this.form.value.postDescription}}}.
        //         {{Generate atleast one emoticon per bullet point in unicode representation that can be rendered in web application}}
        //       </li>
        //     </ul>
        // </div>

        this.callPalm(promptInput, 0);
    }

    showRecentPosts() {
        let promptInput = `\n
      You are a friendly personal assistant.
      First of all remember to NOT include any images or img tags in your output.
      You have generated content for linkedin post on the topic: ${this.form.value.postDescription}.

    You should use the below example HTML structure to create the output:
    <!-- Start of Example -->
      <html id="recent-posts">
          <body>
            <div class="card p-3">
              <p class="tip-heading">Related trending topics in Linkedin</p>
                <ul>
                  <li>
                    {{Include here not more than 4 bullet points for following. I need you to search and pull 4 trending topics in Linkedin which are related to ${this.form.value.postDescription} }}.
                  </li>
                </ul>
            </div>
          </body>
      </html>
      <!-- End of Example -->

      Do not include the following html tags in your response: <a>, <img>
    \n`;
        this.callPalm(promptInput, 0);
    }

    prefillSampleData(index: number) {
        this.form.patchValue(SAMPLE_DATA.form_value);
        this.form.value.postDescription = this.postDescriptions[index].value;
        this.form.patchValue(this.form.value);
    }
}
